import { Dispatch, SetStateAction } from "react";

import useQuickFilters from "hooks/filters/useQuickFilters";
import FilterAccordions from "components/organisms/Filter/components/FilterAccordions";

interface EditFilterProps {
  currentFilters: Record<string, any> | undefined;
  setFilters: Dispatch<SetStateAction<Record<string, any> | undefined>> | Function;
}

function EditQuickFilter({ currentFilters, setFilters }: EditFilterProps) {
  const { config } = useQuickFilters();

  const eventContext = "Edit Quick Preset";

  if (!currentFilters) return null;
  return (
    <FilterAccordions config={config} currentFilters={currentFilters} setFilters={setFilters} eventContext={eventContext} />
  );
}

export default EditQuickFilter;
